import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';
import logo from "../Assets/Kalam Kids Logo_newlogo.png";

const numberToWords = (num) => {
    const ones = [
      '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
      'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen',
      'Seventeen', 'Eighteen', 'Nineteen'
    ];
    const tens = [
      '', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'
    ];
    const thousands = ['', 'Thousand', 'Million', 'Billion'];
  
    if (num === 0) return 'Zero';
  
    let words = '';
    let i = 0;
  
    while (num > 0) {
      const chunk = num % 1000;
      if (chunk) {
        let chunkWords = '';
        if (chunk % 100 < 20) {
          chunkWords = ones[chunk % 100];
        } else {
          chunkWords = tens[Math.floor((chunk % 100) / 10)] + (chunk % 10 ? ' ' + ones[chunk % 10] : '');
        }
        if (Math.floor(chunk / 100) > 0) {
          chunkWords = ones[Math.floor(chunk / 100)] + ' Hundred' + (chunkWords ? ' ' + chunkWords : '');
        }
        words = chunkWords + ' ' + thousands[i] + (words ? ' ' + words : '');
      }
      num = Math.floor(num / 1000);
      i++;
    }
  
    return words.trim();
  };
const OverallResipt = () => {
    const location = useLocation();
    const [ form, setBill] = useState(location.state?.form || null); // Use local state for bill
  
    useEffect(() => {
      if (! form) {
        const storedoverallBill = localStorage.getItem("downloadoverll");       
        if (storedoverallBill) {
          setBill(JSON.parse(storedoverallBill));
        }
      }
    }, [ form]);
    if (!form) return <p className="text-[#16bab1]enter text-gray-500">No data available.</p>;

    const totalAmount = form.feePayments?.reduce((sum, pay) => sum + pay.amount, 0);
    const totalAmountInWords = numberToWords(totalAmount);
    const handlePrint = () => {
        window.print();
      };
      
  return (
    <div className="max-w-4xl  navbar-link mx-auto p-6 text-[14px] text-gray-800 bg-white">
        <style>
        {`
          @media print {
            body {
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }
            .print\\:hidden {
              display: none;
            }
            table, th, td {
              border: 1px solid #000;
              border-collapse: collapse;
            }
          }
        `}
      </style>
<div className="text-right mb-4 print:hidden">
  <button
    onClick={handlePrint}
    className="bg-[#16bab1] hover:bg-[#dbac38] text-white font-bold py-2 px-4 rounded"
  >
    🖨️ Print Receipt
  </button>
</div>


    {/* Printable Section */}
    <div  className="p-6">
      {/* Logo and Branch Address */}
      <div className="flex justify-between items-start mb-4">
        <div className="text-left">
          <img src={logo} alt="Kalam Kids Logo" className="w-40" />
          {form.branch && form.branch.address && (
            <p className="text-sm text-gray-600 mt-2">{form.branch.address}</p>
          )}
        </div>
        {/* Right aligned section (if any) can go here */}
      </div>

      {/* Personal + Academic Details */}
      <div className="grid grid-cols-2 gap-x-8 mb-6">
        <div className="flex flex-col">
          <h3 className="font-bold text-lg mb-4">Personal Details</h3>
          {[
            { label: "Admission No.", element: <span className='bg-gray-200 px-3 py-1 flex-1'>{form.invoiceNo}</span> },
            { label: "Name of the Kid", element: <span className='bg-gray-200 px-3 py-1 flex-1'>{form.particularsOfChild?.fullName}</span> },
            { label: "Father’s Name", element: <span className='bg-gray-200 px-3 py-1 flex-1'>{form.particularsOfParents?.FatherName}</span> },
            { label: "Mother’s Name", element: <span className='bg-gray-200 px-3 py-1 flex-1'>{form.particularsOfParents?.MotherName}</span> },
            { label: "Address", element: <span className='bg-gray-200 px-3 py-1 flex-1'>{form.address}</span> },
          ].map(({ label, element }, i) => (
            <div key={i} className="flex space-x-1 items-center mb-2">
              <label className="bg-[#16bab1] text-white text-nowrap w-36 px-2 py-1">{label}</label>
              {element}
            </div>
          ))}
        </div>

        <div className="flex flex-col">
          <h3 className="font-bold text-lg mb-4">Academic Details</h3>
          {[
            { label: "Class", element: <span className='bg-gray-200 px-3 py-1 flex-1'>{form.admissionFor}</span> },
            { label: "Academic Year", element: <span className='bg-gray-200 px-3 py-1 flex-1'>{form.createdAt?.slice(0, 4)}</span> },
            { label: "Total Fees", element: <span className='bg-gray-200 px-3 py-1 flex-1'>₹{form.feeAmount}</span> },
            { label: "Amount in Words", element: <span className='bg-gray-200 px-3 py-1 flex-1'>{totalAmountInWords}</span> },
          ].map(({ label, element }, i) => (
            <div key={i} className="flex space-x-1 items-center mb-2">
              <label className="bg-[#16bab1] text-white text-nowrap w-36 px-2 py-1">{label}</label>
              {element}
            </div>
          ))}
        </div>
      </div>

      {/* Payment Table */}
      <div className="mb-6">
        <h3 className="font-bold text-lg mb-2">Details of Payment</h3>
        <table className="w-full table-fixed border">
          <thead>
            <tr className="bg-[#16bab1] text-white">
              <th className="border border-white px-2 py-1">S. No</th>
              <th className="border border-white px-2 py-1">Receipt No</th>
              <th className="border border-white px-2 py-1">Mode of Payment</th>
              <th className="border border-white px-2 py-1 text-right">Amount</th>
            </tr>
          </thead>
          <tbody>
            {form.feePayments?.map((payment, index) => (
              <tr key={payment._id || index}>
                <td className="border-b px-2 py-1 text-[#16bab1]enter">{index + 1}</td>
                <td className="border-b px-2 py-1 text-[#16bab1]enter">{payment._id}</td>
                <td className="border-b px-2 py-1 text-[#16bab1]enter">{payment.paidBy}</td>
                <td className="border-b px-2 py-1 text-right">₹{payment.amount}</td>
              </tr>
            ))}
            <tr>
              <td colSpan={3} className="px-2 py-1 text-right font-semibold">Total:</td>
              <td className="px-2 py-1 text-right font-semibold">₹{totalAmount}</td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Note */}
      <p className="italic text-sm mb-8">
        <strong>Note:</strong> Fees once paid will not be refunded.
      </p>

      {/* Footer */}
      <div className="flex justify-between items-end text-sm">
        <div>
          <p><strong>Principal</strong></p>
          <p>(Sign with Seal)</p>
          <div className="mt-6 border-t border-gray-500 w-32"></div>
        </div>
      </div>
    </div>
  </div>
  )
}

export default OverallResipt